(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/middlewares/error-handler-middleware.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/middlewares/error-handler-middleware.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


const errors = svs.racing.gameEngine.errors;
const getDialogContents = error => {
  switch (error.type) {
    case errors.INVALID_COUPON:
      {
        const message = error.numInvalid > 1 ? 'flera hästar' : 'en häst';
        return {
          message: [{
            text: "Observera att ".concat(message, " i det h\xE4r loppet har strukits och f\xF6ruts\xE4ttningarna kan ha \xE4ndrats."),
            type: svs.components.dialog.message.TEXT
          }],
          title: 'Struken häst'
        };
      }
    case errors.INVALID_SELECTION:
      {
        const message = error.numInvalid > 1 ? 'flera' : 'en';
        return {
          message: [{
            text: "Observera att ".concat(message, " av dina valda h\xE4star i det h\xE4r loppet har strukits."),
            type: svs.components.dialog.message.TEXT
          }],
          title: 'Struken häst'
        };
      }
    default:
      return undefined;
  }
};

const errorHandlerMiddleware = (dispatch, engine) => next => (state, action) => {
  const newState = next(state, action);
  if (newState && newState.error) {
    const dialogContents = getDialogContents(newState.error);
    if (dialogContents) {
      const dialog = new svs.components.dialog.Confirm(_objectSpread(_objectSpread({
        actions: [{
          callback() {
            dialog.close();
          },
          title: 'Ok'
        }],
        branding: svs.components.dialog.branding.SPORT
      }, dialogContents), {}, {
        icon: 'help-2'
      }));
      dispatch(engine.actions.clearError());
      svs.components.dialog.api.add(dialog);
    }
  }
  return newState;
};
svs.racing.gameEngine.middlewares.errorHandler = errorHandlerMiddleware;

 })(window);